import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { UserCheck, UserX } from 'lucide-react';

const NavBar: React.FC = () => {
  const { accessToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const isAuthenticated = !!accessToken;

  return (
    <nav className="bg-background border-b sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center h-16 px-4">
        <Link to={isAuthenticated ? "/dashboard" : "/"} className="font-semibold text-xl tracking-tight text-foreground">
          Schwinghub
        </Link>
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1 text-sm">
             {isAuthenticated ? (
                <UserCheck className="h-5 w-5 text-green-500" />
             ) : (
                <UserX className="h-5 w-5 text-red-500" />
             )}
             <span>{isAuthenticated ? 'Logged In' : 'Logged Out'}</span>
          </div>
          {isAuthenticated ? (
            <>
              <Button variant="link" asChild>
                <Link to="/dashboard">Dashboard</Link>
              </Button>
              <Button variant="link" asChild>
                <Link to="/goal-planner">Goal Planner</Link>
              </Button>
              <Button variant="ghost" onClick={handleLogout}> 
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button variant="link" asChild>
                <Link to="/">Home</Link>
              </Button>
              <Button variant="link" asChild>
                <Link to="/login">Login</Link>
              </Button>
              <Button variant="ghost" asChild>
                <Link to="/register">Register</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar; 